import axios from "../../API/apiConfig";

// API to get products list with pagination and filters
export const getProducts = (filters) => {
  const url = "/products";
  
  // Create query parameters from filters
  const params = {
    pageNo: filters?.pageNo || 0,
    pageSize: filters?.pageSize || 10,
    property: filters?.property || "id",
    direction: filters?.direction || "ASC",
    productName: filters?.productName || null,
    productCode: filters?.productCode || null,
    category: filters?.category || null
  };
  return axios.get(url, { params });
};
// // API to add a new product
// export const listProduct = () => {
//   const url = "/products";
//   return axios.get(url);
// };

// API to add a new product
export const addProduct = (productData) => {
  const url = "/products/add";
  return axios.post(url, productData);
};

// API to update product information
export const updateProduct = (productId, productData) => {
  const url = `/products/update/${productId}`;
  return axios.put(url, productData);
};

// API to delete a product
export const deleteProduct = (productId) => {
  const url = `/products/${productId}`;
  return axios.delete(url);
};

// API to get details of a product
export const getProductDetail = (productId) => {
  const url = `/products/detail/${productId}`;
  return axios.get(url);
}; 
// API to get all Price Book
export const getAllPricebooks = () => {
  const url = "/price_books/list-all";
  return axios.get(url);
};
// API to add product into a Price Book
export const addProductPriceBook = (productData) => {
  const url = `/product_price_books/add`;
  return axios.post(url, productData);
};
// API to get all products
export const getAllProducts = () => {
  const url = "/products/list-all";
  return axios.get(url);
};
// API to delete a product pricebook
export const deleteProductPriceBook = (productPriceBookId) => {
  const url = `/product_price_books/delete/${productPriceBookId}`;
  return axios.delete(url);
};
// API to update a product pricebook
export const updateProductPriceBook = (productId, productData) => {
  const url = `/product_price_books/update/${productId}`;
  return axios.put(url, productData);
};
// API to get details of a product pricebook
export const getProductPriceBookDetail = (productId) => {
  const url = `/product_price_books/detail/${productId}`;
  return axios.get(url);
}; 
